import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AppRoute } from 'src/app/constants/app.route';
import { Authority } from 'src/app/constants/authority';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { AuthenticatedUserService } from 'src/app/core/services/http/authenticated-user/authenticated-user.service';
import { User } from 'src/app/core/services/http/user/interfaces/user';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html'
})
export class MyProfileComponent extends DestroyNotifierComponent implements OnInit {
  authority = Authority;
  appRoute = AppRoute;
  route = AppRoute.MyProfile;
  user: User | undefined;
  uuid: string | undefined;

  constructor(
    private authenticatedUserService: AuthenticatedUserService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadUser();
  }

  onBack(): void {
    this.router.navigateByUrl(AppRoute.Schedule);
  }

  private loadUser(): void {
    this.authenticatedUserService
      .getAuthenticatedUser()
      .pipe(takeUntil(this.destroyNotify))
      .subscribe(user => {
        this.user = user;
      });
  }
}
